// extracted by mini-css-extract-plugin
export var content = "_av-3";
export var list = "_av-4";
export var settingsContent = "_av-7";
export var settingsPanel = "_av-8";
export var state = "_av-6";
export var triggerBadge = "_av-2";
export var triggerButton = "_av-1";
export var triggerShell = "_av-0";
export var unreadDot = "_av-5";